export const locales = {
  "en": "en",
  "tr": "tr"
};

export const initialLanguage = locales.en;

export const storeEncriptionKey = "Q8PL5liE0XgswM6Mt8xW2eAwuS6o9cBB";